import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const PinOutlineIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16' {...props} ref={ref}>
        <path
            fill='currentColor'
            d='m14.47 6.533-.665-.667L9.477 1.53l-.004-.004a.665.665 0 0 0-.946.008.668.668 0 0 0 .004.943l.2.193-2.964 2.936a6.647 6.647 0 0 0-3.329.44.668.668 0 0 0-.426.48c-.043.222.03.45.193.607l2.829 2.833-2.7 2.7-.667 1.666 1.666-.667 2.7-2.698 2.831 2.836c.163.161.397.226.62.174a.666.666 0 0 0 .479-.427 6.676 6.676 0 0 0 .439-3.335l2.93-2.935.193.2a.668.668 0 1 0 .946-.947ZM9.178 9.515a.668.668 0 0 0-.167.667 3.824 3.824 0 0 1 0 1.881L3.937 6.98a3.81 3.81 0 0 1 1.878 0 .665.665 0 0 0 .666-.167L9.67 3.61l2.703 2.709-3.196 3.195Z'
        />
    </svg>
));
